// extracted by mini-css-extract-plugin
module.exports = {"tabsOuterWrapper":"efqjDuz4zcS8J8v0kzcn0A==","reviews":"tVx6F6XHb2SLAnMigFg0vg==","reviewItem":"Npaep9vsqQdOxpWej1P28A=="};